import ChipColors from './ChipColors';

export default [
  {
    value: 'User',
    text: 'Usuário',
    ...ChipColors.light,
  },
  {
    value: 'Client',
    text: 'Cliente',
    ...ChipColors.wait,
  },
  {
    value: 'Store',
    text: 'Loja',
    ...ChipColors.warning,
  },
];
